import { useQueryClient } from "@tanstack/react-query";
import {
  PatientAssessmentControllerXApi,
  PatientAssessments,
} from "../../../../services";
import {
  getConfigObject,
  getXtenantId,
  useMutationWithLoading,
} from "../../../../utils/utils";

interface Props {
  patientAssessments: PatientAssessments;
  patientIds: string[];
}

/**
 * @author Rajkumar Rathod
 */
export const useSendPatientAssessments = () => {
  const queryClient = useQueryClient();
  return useMutationWithLoading(
    async (params: Props) =>
      new PatientAssessmentControllerXApi(getConfigObject()).sendAssessment(
        {
          ...params.patientAssessments,
          patientIds: params.patientIds,
        },
        getXtenantId()
      ),
    {
      // Sending an assessment to a patient typically posts a new
      // requiring-action and may also be reflected in the chart
      // timeline. Invalidate both so the Provider Timeline refreshes.
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["patient-chart-assessment-list"],
        });
        queryClient.invalidateQueries({ queryKey: ["requiring-action"] });
        queryClient.invalidateQueries({ queryKey: ["chronological-record"] });
      },
    }
  );
};
